<template>
  <div class="alert">
    <div class="el-icon-ali-jinggao blue" style="margin-right: 8px"></div>
    <div>
      通知：因企业微信客服账号正在变更中，平台客服二维码已更新，有问题请联系<span
        class="blue"
        style="cursor: pointer"
       @click="setServicepopupvisible({visible:true})"
        >新平台客服。</span
      >
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
export default {
  methods: {
    ...mapActions("app", ["setServicepopupvisible"]),
  },
};
</script>

<style lang="scss" scoped>
.alert {
  width: calc(100% - 16px);
  border-radius: 2px;
  background: #eff6ff;
  display: flex;
  align-items: center;
  height: 40px;
  padding: 0 16px;
  // color: #0062ff;
  font-family: "Noto Sans SC";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 26px;
  /* 185.714% */
  .blue {
    color: #0062ff;
  }
}
</style>
